import { Integration } from "../../../types"
import { BB_DETAILS } from "../../constants"

export const buildSupportMailto = (
  integration: Integration,
  userName: string,
  userEmail: string
): string => {
  const subject = encodeURIComponent(
    `Technical Support — ${integration.title || "Integration"} (ID: ${
      integration.id
    })`
  )
  const body = [
    `Integration: ${integration.title || ""}`,
    `Integration ID: ${integration.id}`,
    `App Key: ${integration.app_key || "N/A"}`,
    `URL: ${integration.url || "N/A"}`,
    ``,
    `Name: ${userName}`,
    `Email: ${userEmail}`,
    ``,
    `Issue:`
  ]
    .map(line => encodeURIComponent(line))
    .join("%0A")

  return `mailto:${BB_DETAILS.email}?subject=${subject}&body=${body}`
}
